import FastMarquee from "react-fast-marquee";

const WORDS = [
  "Air in",
  "Doubt out",
  "Breethe harder",
  "Sleep deeper",
  "Run longer",
  "Founders eat first",
];

const MarqueeStrip = () => (
  <section
    data-testid="marquee-section"
    className="border-y border-white/10 py-6 md:py-8 overflow-hidden bg-[#0A0A0A]"
  >
    <FastMarquee speed={35} gradient={false} pauseOnHover>
      {WORDS.map((word, i) => (
        <span key={word} className="flex items-center">
          <span
            className={`font-anton uppercase text-5xl md:text-7xl leading-none mx-6 md:mx-10 ${
              i % 2 === 0 ? "text-outline" : "text-white"
            }`}
          >
            {word}
          </span>
          <span className="font-plex text-volt text-xl md:text-2xl">//</span>
        </span>
      ))}
    </FastMarquee>
  </section>
);

export default MarqueeStrip;
